import service from '../../../@services'
import { useState, useMemo, useEffect } from 'react'
import useProcurementTypeContext from './useProcurementTypeContext'
import useFullListGetPageData from '../../../@hooks/useFullListGetPageData'
import useUpLoadGetProductList from '../../../@hooks/useUpLoadGetProductList'
import { plusMumber, getNumProduct } from '../../../@utils'
import { amountStyle } from '../components/ProcurementDetail'
import { message } from 'antd'
const colorStyle = { color: '#FA4B54' }
const rowKey = 'barcode'
export default function useOperateAddProductList({ supplierId, storeId, type = null }) {
  const [page, setPage] = useState({
    pageIndex: 1,
    pageSize: 10
  })
  const { isOrder } = useProcurementTypeContext()
  const [list, setList] = useState([])
  const listBarcodes = useMemo(() => list.map(item => item.barcode), [list])
  const { list: uploadedList, uploadBtn } = useUpLoadGetProductList({
    actionUrl: isOrder
      ? 'purchase-order/import-product'
      : 'purchase-return/import-product',
    requestData: { supplierId },
    disabled: !supplierId,
    beforeUpload: file => {
      if (!supplierId) {
        message.info('请选择所属供应商')
        return Promise.reject('')
      } else {
        return Promise.resolve(file)
      }
    }
  })
  const { pageData } = useFullListGetPageData({ list, page })
  const getProductInfoBySeachModal = async _list => {
    let $list = _list.filter(item => listBarcodes.indexOf(item.barcode) < 0)
    if (isOrder) {
      if (type && type == 'OrderCostPrice'){
        let finalList = await getOrderCostPriceByBarcodeList({
          barcodes: $list.map(item => item.barcode),
          supplierId,
          storeId
        })
        finalList.forEach((i)=> (i.costPrice = i.refCostPrice))
        setList([...finalList, ...list])
      }else{
        setList([
          ...$list.map(item => ({
            ...item,
            productName: item.name,
            skuName: item.name,
            productCode: item.outProductNo,
            categoryId: item.merchantCategoryId,
            unit: item.packageUnitName,
            costPrice: item.costPrice,
          })),
          ...list
        ])
      }


    } else {
      if ($list && $list.length > 0) {
        let finalList = await getRefCostPriceByBarcodeList({
          barcodes: $list.map(item => item.barcode),
          supplierId,
          storeId,
        })
        setList([...finalList, ...list])
      }
    }
  }
  const handleSave = row => {
    const newData = [...list]
    const index = newData.findIndex(item => row[rowKey] === item[rowKey])
    row.costTotal = row.quantity * row.costPrice
    const item = newData[index]
    newData.splice(index, 1, { ...item, ...row })
    setList(newData)
  }
  const deleteRecord = record => {
    setList(list.filter(item => item.barcode !== record.barcode))
  }
  useEffect(() => {
    if (uploadedList.length) {
      setList(uploadedList)
    }
    return () => {}
  }, [uploadedList])
  const totalAmountData = useGetDisplayDataByList(list)
  return {
    pageData,
    handleSave,
    deleteRecord,
    getProductInfoBySeachModal,
    setPage,
    uploadBtn,
    totalAmountData,
    list,
    setList,
    rowKey,
    otherText: isOrder ? (
      <div style={amountStyle}>
        共 <span style={colorStyle}>{totalAmountData.totalCate}</span>
        &nbsp;种商品，采购数量&nbsp;
        <span style={colorStyle}>{totalAmountData.totalCount}</span>
        &nbsp;成本总额：&nbsp;
        <span style={colorStyle}>{totalAmountData.totalAmount}</span> 元
      </div>
    ) : (
      <div style={amountStyle}>
        共 <span style={colorStyle}>{totalAmountData.totalCate}</span>
        &nbsp;种商品，出库数量&nbsp;
        <span style={colorStyle}>{totalAmountData.totalCount}</span>
        &nbsp;总退款金额：&nbsp;
        <span style={colorStyle}>{totalAmountData.totalAmount}</span>&nbsp;元
      </div>
    )
  }
}
// 用于计算综合数量
const useGetDisplayDataByList = (list = []) => {
  const { totalCate, totalCount, totalAmount } = useMemo(() => {
    let cataList = [],
      _totalCount = 0,
      _totalAmount = 0
    if (list.length > 0) {
      list.map(item => {
        cataList.indexOf(item.categoryName) < 0 &&
          cataList.push(item.categoryName)
        _totalCount = plusMumber(
          _totalCount,
          item.quantity ? item.quantity - 0 : 0
        )
        _totalAmount =
          item.costPrice && item.quantity
            ? plusMumber(
                _totalAmount,
                getNumProduct(item.quantity, item.costPrice)
              )
            : _totalAmount
      })
    }
    return {
      totalCate: list.length,
      totalCount: _totalCount,
      totalAmount: _totalAmount
    }
  }, [list])
  return {
    totalCate,
    totalCount,
    totalAmount
  }
}
const getRefCostPriceByBarcodeList = ({ barcodes = [], supplierId = '', storeId = '' }) =>
  service.purchaseReturn.getRefCostPrice({ barcodeLists: barcodes, supplierId, storeId })

const getOrderCostPriceByBarcodeList = ({ barcodes = [], supplierId = '', storeId ='' }) =>
  service.purchaseOrder.getRefCostPrice({ barcodeLists: barcodes, supplierId, storeId })
